import Client from '../client/client';
import SiteDto from './site-dto';

export default class Site
{
    public dto!: SiteDto;

    public constructor(dto: SiteDto)
    {
        this.dto = Object.assign({}, dto);

        this._clientId = this.dto.client ? this.dto.client.id : null;
    }

    public get id(): number|null
    {
        return this.dto.id;
    }

    public set id(id: number|null)
    {
        this.dto.id = id;
    }

    public get client(): Client|null
    {
        if (!this.dto.client)
        {
            return null;
        }

        return new Client(this.dto.client);
    }

    private _clientId: number|null = null;

    public get clientId(): number|null
    {
        return this._clientId;
    }

    public set clientId(id: number|null)
    {
        this._clientId = id;
    }

    public get name(): string
    {
        return this.dto.name;
    }

    public set name(name: string)
    {
        this.dto.name = name;
    }
}